import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Chart, ChartData } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-histogram',
  template: `
  <div style="display: block;">
    <canvas id="histogramChart">
    </canvas>
  </div>
  `,
  styleUrls: ['./histogram.component.scss'],
  providers: [DecimalPipe]
})

export class HistogramComponent implements AfterViewInit {
  @Input() groups: string[];
  @Input() data: number[];

  chart: Chart;

  constructor(private decimalPipe: DecimalPipe) {
    
  }

  ngAfterViewInit() {
    this.createChart();
  }

  createChart() {
    const largestValue = Math.max(...this.data)
    const maxXValue = Math.ceil((largestValue + 10) / 10) * 10;

    this.chart = new Chart("histogramChart", {
      type: 'horizontalBar',
      data: {
        labels: this.groups,
        datasets: [
          {
            data: this.data,
            backgroundColor: '#635392'
          }
        ]
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                max: maxXValue
              },
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#635392',
            formatter: (value, context) => {
              return this.formatNumber(value) + '%';
            }
          }
        }
      },
      plugins: [ChartDataLabels] // Register the ChartDataLabels module
    });
  }

  // Function to format a number using decimal separator and thousands separator
  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.0-1').replace('.', '|').replace(',', '.').replace('|', ',');
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/histogram/histogram.component.ts